import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { filter } from 'underscore';

import Login from '../RegistrationSlides/LoginSlidePart'
import Welcome from '../RegistrationSlides/WelcomeSlidePart'
import WhatStage from '../RegistrationSlides/WhatStageSlidePart'
import Turnover from '../RegistrationSlides/TurnoverSlidePart'
import Staff from '../RegistrationSlides/StaffSlidePart'
import QuestionsIntro from '../RegistrationSlides/QuestionsIntroSlidePart'
import Clients from '../RegistrationSlides/ClientsSlidePart'
import Operations from '../RegistrationSlides/OperationsSlidePart'
import Ambition from '../RegistrationSlides/AmbitionSlidePart'
import Interests from '../RegistrationSlides/InterestsSlide'
import AllDone from '../RegistrationSlides/AllDoneSlidePart'

import { getSessionByAccessToken, getSessionByEmail } from '../../../actions/sessions'

class MasterSlide extends React.Component {
    static propTypes = {
		title: PropTypes.string,
		slideName: PropTypes.string,
		stripe_customer_id: PropTypes.string,
		changeSlide: PropTypes.func,
		dispatch: PropTypes.func,
		history: PropTypes.object,
		session: PropTypes.object,
		interests: PropTypes.array,
		loginOnly: PropTypes.bool.isRequired
	};

    state = {
        returnedData: {
            core_data: {},
            custom_data: {},
            acf_data: {}
        }
    };

    loginOrCreateAccount = (network, responseData) => {
    	console.log(network, responseData, this.props)
		// TODO:
		// if( !this.props.loginOnly && !this.props.stripe_customer_id ) return
		network === 'email'
			? this.props.getSessionByEmail(responseData, !this.props.loginOnly ? this.props.stripe_customer_id : '')
			: this.props.getSessionByAccessToken(network, responseData)
	};

    prevSlide = () => {
		this.props.changeSlide('prev', this.state.returnedData)
		this.setState({
			returnedData: {}
		})
	};

    nextSlide = () => {
		this.props.changeSlide('next', this.state.returnedData)
		this.setState({
			returnedData: {}
		})
	};

    returnData = (core_data, custom_data) => {

		for( var field in core_data ) {
			this.state.returnedData.core_data[field] = core_data[field]
		}

		for( var field in custom_data ) {
			this.state.returnedData.custom_data['boma_registration_' + field] = custom_data[field]
		}

	};

    render() {

		let interests = filter(this.props.interests, function(i) { return !!i.top_level; });

		return (
			<fieldset>
				{ ( () => {
					switch (this.props.slideName) {
						case "Login": 			return <Login loginOrCreateAccount={this.loginOrCreateAccount} loginOnly={this.props.loginOnly} session={this.props.session} />
						case "Welcome": 		return <Welcome nextSlide={this.nextSlide} loginOnly={this.props.loginOnly} />
						case "WhatStage": 		return <WhatStage prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "TurnoverNow": 	return <Turnover nowOrGoal="now" prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "TurnoverGoal": 	return <Turnover nowOrGoal="goal" prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "StaffNow": 		return <Staff nowOrGoal="now" prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "StaffGoal": 		return <Staff nowOrGoal="goal" prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "QuestionsIntro": 	return <QuestionsIntro prevSlide={this.prevSlide} nextSlide={this.nextSlide} history={this.props.history} dispatch={this.props.dispatch} />
						case "Clients": 		return <Clients prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "Operations": 		return <Operations prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "Ambition": 		return <Ambition prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} sessionUser={this.props.session ? this.props.session.user : {}} />
						case "Interests": 		return <Interests prevSlide={this.prevSlide} nextSlide={this.nextSlide} dispatch={this.props.dispatch} interests={interests} userInterests={this.props.session ? this.props.session.interests : []} />
						case "AllDone": 		return <AllDone prevSlide={this.prevSlide} nextSlide={this.nextSlide} changeData={this.returnData} history={this.props.history} dispatch={this.props.dispatch} />
					}
				} )() }
			</fieldset>
		)
	}
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getSessionByAccessToken,
    getSessionByEmail,
}, dispatch);

export default connect(
	null,
	mapDispatchToProps
)(MasterSlide);


// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/MasterSlide.jsx